/* Gamers Point search enhancement — unpublished review theme
 * Shopify Ajax Predictive Search, no external services or new apps.
 * No product availability, shipping or price promises in suggestions.
 */
(() => {
  "use strict";
  if (window.__gpSmartSearchLoaded) return;
  window.__gpSmartSearchLoaded = true;
  const form=document.querySelector("[data-gp-smart-search]");
  if (!form) return;
  const input=form.querySelector("[data-gp-smart-input]");
  const panel=form.querySelector("[data-gp-smart-panel]");
  const resultBox=form.querySelector("[data-gp-smart-results]");
  const clearButton=form.querySelector("[data-gp-smart-clear]");
  const status=form.querySelector("[data-gp-search-status]");
  const viewAll=form.querySelector("[data-gp-smart-viewall]");
  const starters=form.querySelector("[data-gp-search-starters]");
  if(!input||!panel||!resultBox||!clearButton||!status||!viewAll) return;
  const quickLinks=[
    {label:"Gaming PCs",href:"/collections/all-gaming-pcs-custom-ready-rtx-5000-builds"},
    {label:"Graphics Cards",href:"/collections/gpu-graphic-cards"},
    {label:"Gift Cards",href:"/collections/gift-cards"},
    {label:"PC Builder",href:"/pages/pc-assembly-guide?view=gp-builder"}
  ];
  let controller=null,debounce=null,requestSeq=0,visibleItems=[];
  const cache=new Map();
  const cacheMax=20;
  const el=(tag,cl,txt)=>{
    const node=document.createElement(tag);
    if(cl)node.className=cl;
    if(txt!==undefined)node.textContent=txt;
    return node;
  };
  const localeRoot=window.Shopify?.routes?.root||"/";
  const onlyInternal=(href)=>{
    if(typeof href!=="string"||!href)return null;
    try {const url=new URL(href,window.location.origin);
      return url.origin===window.location.origin&&["http:","https:"].includes(url.protocol)?url.pathname+url.search+url.hash:null;
    }catch{return null;}
  };
  const searchLink=()=>{
    const url=new URL(form.action,window.location.origin);
    url.searchParams.set("type","product");
    url.searchParams.set("q",input.value.trim());
    return url.pathname+url.search;
  };
  function show() {panel.hidden=false;input.setAttribute("aria-expanded","true");}
  function hide() {panel.hidden=true;input.setAttribute("aria-expanded","false");}
  function reset() {resultBox.replaceChildren();visibleItems=[];}
  function addTitle(text) {resultBox.appendChild(el("div","gp-smart-heading",text));}
  function addLink(text,href,subtitle,image,isProduct=false){
    const safe=onlyInternal(href);
    if(!safe)return;
    const a=el("a","gp-smart-result"+(isProduct?" gp-smart-result--product":""));
    a.href=safe;a.setAttribute("data-gp-smart-result","");
    if(isProduct){
      const holder=el("span","gp-smart-thumb");
      if(image&&/^https:\/\//i.test(image)){
        const im=el("img","gp-smart-result__image"); im.src=image;im.alt="";
        im.width=58;im.height=58;im.loading="eager";im.decoding="async";
        im.onerror=()=>{im.remove();holder.appendChild(el("span","gp-smart-thumb-placeholder","GP"));};
        holder.appendChild(im);
      }else holder.appendChild(el("span","gp-smart-thumb-placeholder","GP"));
      a.appendChild(holder);
    }
    const copy=el("span","gp-smart-result__copy");
    copy.append(el("strong","",text),el("small","",subtitle));
    a.append(copy,el("span","gp-smart-result__arrow","↗"));
    resultBox.appendChild(a);visibleItems.push(a);
  }
  function showQuick(){
    reset();
    if(starters){
      const cards=starters.querySelectorAll("[data-gp-starter-item]");
      if(cards.length){
        addTitle("Featured products");
        [...cards].forEach(card=>{
          const copy=card.cloneNode(true);copy.removeAttribute("tabindex");
          resultBox.appendChild(copy);visibleItems.push(copy);
        });
      }
    }
    addTitle("Browse popular categories");
    quickLinks.forEach(x=>addLink(x.label,x.href,"Browse category"));
    status.textContent="Real products from Gamers Point";
    viewAll.hidden=true;
    show();
  }
  function showMessage(message){
    reset();resultBox.appendChild(el("p","gp-smart-message",message));
    status.textContent="Full catalog search is available";
    viewAll.hidden=false;viewAll.href=searchLink();
    show();
  }
  const productImage=p=>{
    const raw=[p?.featured_image?.url,p?.image,p?.variants?.[0]?.featured_image?.url,p?.variants?.[0]?.image]
      .find(item=>typeof item==="string"&&item.length);
    if(!raw)return null;
    const normalized=raw.startsWith("//")?"https:"+raw:raw;
    try{const url=new URL(normalized,location.href);return url.protocol==="https:"?url.href:null;}catch{return null;}
  };
  const displayPrice=p=>{
    const n=Number(p?.price);
    if(!Number.isFinite(n)||n<0)return null;
    try{return new Intl.NumberFormat(document.documentElement.lang==="ar"?"ar-BH":"en-BH",{
      style:"currency",currency:window.Shopify?.currency?.active||"BHD"
    }).format(n);}catch{return null;}
  };
  function showResults(data,query){
    const results=data?.resources?.results||{};
    const products=Array.isArray(results.products)?results.products.slice(0,6):[];
    const collections=Array.isArray(results.collections)?results.collections.slice(0,3):[];
    reset();
    if(products.length){addTitle("Products");
      products.forEach(p=>{
        if(!p||!p.title||!p.url)return;
        const image=productImage(p);
        const price=displayPrice(p);
        const info=[p.vendor,price].filter(Boolean).join(" · ")||"Product";
        addLink(p.title,p.url,info,image,true);
      });
    }
    if(collections.length){addTitle("Categories");
      collections.forEach(c=>{if(c?.title&&c?.url)addLink(c.title,c.url,"View collection");});
    }
    if(visibleItems.length===0)resultBox.appendChild(el("p","gp-smart-message","No quick matches. Press Enter to search the full catalog."));
    status.textContent=visibleItems.length?visibleItems.length+" suggestions":"Try the full catalog search";
    viewAll.href=searchLink();viewAll.hidden=false;show();
  }
  async function predict(query){
    if(controller)controller.abort();
    controller=new AbortController();
    const seq=++requestSeq;
    const key=query.toLocaleLowerCase();
    if(cache.has(key)){showResults(cache.get(key),query);return;}
    const qs=new URLSearchParams({
      q:query,
      "resources[type]":"product,collection",
      "resources[limit]":"6"
    });
    try{
      const endpoint=new URL(String(localeRoot).replace(/\/?$/,"/")+"search/suggest.json",window.location.origin);
      endpoint.search=qs.toString();
      const response=await fetch(endpoint,{signal:controller.signal,credentials:"same-origin",headers:{"Accept":"application/json"}});
      if(!response.ok)throw new Error("predictive-search-unavailable");
      const data=await response.json();
      if(seq!==requestSeq||input.value.trim()!==query)return;
      cache.set(key,data);
      if(cache.size>cacheMax)cache.delete(cache.keys().next().value);
      showResults(data,query);
    }catch(e){
      if(e.name==="AbortError")return;
      if(seq===requestSeq)showMessage("Suggestions are temporarily unavailable. Press Enter to search normally.");
    }
  }
  input.addEventListener("focus",()=>{
    const v=input.value.trim();if(v.length<2)showQuick();else{viewAll.href=searchLink();show();}
  });
  input.addEventListener("input",()=>{
    const v=input.value.trim();
    clearButton.hidden=!v;
    clearTimeout(debounce);
    if(controller)controller.abort();
    requestSeq++;
    if(v.length<2){showQuick();return;}
    status.textContent="Finding matching products...";
    reset();viewAll.hidden=false;viewAll.href=searchLink();show();
    debounce=setTimeout(()=>predict(v),140);
  });
  clearButton.addEventListener("click",()=>{
    clearTimeout(debounce);if(controller)controller.abort();requestSeq++;
    input.value="";clearButton.hidden=true;input.focus();showQuick();
  });
  input.addEventListener("keydown",e=>{
    if(e.key==="Escape"){if(!panel.hidden){hide();e.preventDefault();}return;}
    if(e.key==="ArrowDown"&&!panel.hidden&&visibleItems.length){
      e.preventDefault();visibleItems[0].focus();return;
    }
  });
  panel.addEventListener("keydown",e=>{
    if(e.key==="Escape"){hide();input.focus();e.preventDefault();return;}
    if(!["ArrowDown","ArrowUp"].includes(e.key))return;
    const current=document.activeElement,all=visibleItems;
    if(!all.length)return;
    const idx=all.indexOf(current);
    e.preventDefault();
    if(e.key==="ArrowDown")all[(idx+1)%all.length].focus();
    else if(idx<=0)input.focus();
    else all[idx-1].focus();
  });
  form.addEventListener("submit",()=>{hide();clearTimeout(debounce);if(controller)controller.abort();});
  document.addEventListener("pointerdown",e=>{if(!form.contains(e.target))hide();});
  document.addEventListener("focusin",e=>{if(!form.contains(e.target))hide();});
  clearButton.hidden=!input.value.trim();
})();